import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

const Rewarding = (props) => {
  return (
    <Fragment>
      <div className="state-label state-label--active">
        <div className="state-label__heading">
          { I18n.t('olympic_participation_decorator.timeline_label.after_main_tour') }
        </div>
      </div>
      <div className="state-label">
        <div className="state-label__date">
          { I18n.t('landing.award_time') }
        </div>
      </div>
    </Fragment>
  )
}

export default Rewarding
